import Axios from 'axios'

const ENDPOINT = 'user'

/**
 * Get
 */
export const getObj = (_id, token = undefined) => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}/${_id}`, { headers: { Authorization: token } })
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * List
 */
export const listObj = () => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Put
 * @param {*} obj
 */
export const putObj = (obj, token = undefined) => {
    return new Promise((resolve, reject) => {
        Axios.put(`/${ENDPOINT}`, obj, { headers: { Authorization: token } })
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Patch
 * @param {*} _id
 * @param {*} obj
 */
export const patchObj = (_id, obj) => {
    delete obj._id
    return new Promise((resolve, reject) => {
        Axios.patch(`/${ENDPOINT}/${_id}`, obj)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

/**
 * Delete
 * @param {*} _id
 */
export const deleteObj = (_id) => {
    return new Promise((resolve, reject) => {
        Axios.delete(`/${ENDPOINT}/${_id}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}

function toBase64(str) {
    return Buffer.from(str).toString('base64')
}

/**
 * Special endpoint to get the user by email
 * @param {*} email
 * @param {*} token
 */
export const getByEmail = (email, token = undefined) => {
    return new Promise((resolve, reject) => {
        Axios.get(`/userByEmail/${toBase64(email.toLowerCase())}`, {
            headers: { Authorization: token },
        })
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
